<script setup lang="ts">
/**
 * Bridge component: Vue 2 v-model (value/input) -> XToggle (modelValue/update:modelValue)
 *
 * Required while using @vue/compat in MODE: 2.
 * Once compat is removed or MODE is set to 3 globally, delete this file
 * and map SwordToggle directly to XToggle in global-components.ts
 */
import { XToggle } from '@swordhealth/ui'

defineProps<{
  value?: boolean
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
}>()

const handleUpdate = (newValue: boolean) => {
  emit('input', newValue)
}
</script>

<template>
  <x-toggle
    v-bind="$attrs"
    :model-value="value"
    @update:model-value="handleUpdate"
  />
</template>
